import { createContext, useContext, type ReactNode } from 'react';
import type { NewReport } from '../../hooks/useNewReport';
import { EditorModals } from './EditorModals';
import { useOverviewEditor, type OverviewEditor } from './useOverviewEditor';

const EditorContext = createContext<OverviewEditor | null>(null);

/**
 * One editor instance for the overview grid and the dock, so both share the open dialog, the focus request and
 * the derived lists instead of each computing their own. The dialogs render here, once.
 */
export function OverviewEditorProvider({ report, children }: { report: NewReport; children: ReactNode }) {
  const editor = useOverviewEditor(report);
  return (
    <EditorContext.Provider value={editor}>
      {children}
      {editor.editing && <EditorModals report={report} editor={editor} />}
    </EditorContext.Provider>
  );
}

export function useEditor(): OverviewEditor {
  const editor = useContext(EditorContext);
  if (!editor) throw new Error('useEditor must be used inside OverviewEditorProvider');
  return editor;
}
